import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { QUALITY } from "@/content/homeContent";

export const Quality = () => {
  return (
    <Section id="quality-protocol-section" tone="light">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHeading
              microLabel={QUALITY.microLabel}
              title={QUALITY.title}
              description={QUALITY.description}
            />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <ul className="divide-y divide-strato-gray-100 border-y border-strato-gray-100">
            {QUALITY.items.map((item, i) => (
              <Reveal key={item.title} delay={i * 0.04}>
                <li
                  data-testid={`quality-item-${i}`}
                  className="flex items-start gap-5 py-5"
                >
                  <MicroLabel className="mt-1 w-8 flex-shrink-0 text-strato-gray-300">
                    {String(i + 1).padStart(2, "0")}
                  </MicroLabel>
                  <div>
                    <p className="font-display text-lg font-medium tracking-[-0.01em] text-strato-graphite">
                      {item.title}
                    </p>
                    <p className="mt-1 text-sm leading-[1.6] text-muted-foreground">
                      {item.description}
                    </p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
